/**
 * LEOS Mission Ready - Ground Station Presets
 * Predefined ground station configurations for training and deployment
 */

export const GROUND_STATION_PRESETS = {
    dsn: [
        { 
            name: 'Goldstone DSN Complex', 
            latitude: 35.4050, 
            longitude: -116.8904, 
            altitude: 1038, 
            type: 'dsn', 
            frequency: 8.4, 
            diameter: 70, 
            range: 15000, 
            description: 'NASA Deep Space Network - Mojave Desert' 
        },
        { 
            name: 'Canberra DSN Complex', 
            latitude: -35.4021, 
            longitude: 148.9819, 
            altitude: 688, 
            type: 'dsn',
            frequency: 8.4, 
            diameter: 70, 
            range: 15000, 
            description: 'NASA Deep Space Network - Australia' 
        },
        { 
            name: 'Madrid DSN Complex', 
            latitude: 40.4275, 
            longitude: -4.2486, 
            altitude: 837, 
            type: 'dsn',
            frequency: 8.4, 
            diameter: 70, 
            range: 15000, 
            description: 'NASA Deep Space Network - Spain' 
        }
    ],
    global: [
        { 
            name: 'Kennedy Space Center', 
            latitude: 28.5721, 
            longitude: -80.6480, 
            altitude: 3, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 20, 
            range: 3000, 
            description: 'NASA Launch & Landing Facility' 
        },
        { 
            name: 'Vandenberg SFB', 
            latitude: 34.5658, 
            longitude: -120.6228, 
            altitude: 112, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 20, 
            range: 3000, 
            description: 'US Space Force Base - Polar Launches' 
        },
        { 
            name: 'Wallops Flight Facility', 
            latitude: 37.9402, 
            longitude: -75.4668, 
            altitude: 13, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 15, 
            range: 2500, 
            description: 'NASA Sounding Rocket Facility' 
        },
        { 
            name: 'Baikonur Cosmodrome', 
            latitude: 45.9650, 
            longitude: 63.3050, 
            altitude: 144, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 25, 
            range: 3500, 
            description: 'Russian Space Launch Facility' 
        },
        { 
            name: 'Kourou Space Centre', 
            latitude: 5.2389, 
            longitude: -52.7681, 
            altitude: 21, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 25, 
            range: 3500, 
            description: 'European Spaceport - French Guiana' 
        },
        { 
            name: 'Tanegashima Space Center', 
            latitude: 30.4010, 
            longitude: 130.9754, 
            altitude: 18, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 20, 
            range: 3000, 
            description: 'JAXA Launch Complex' 
        },
        { 
            name: 'Jiuquan Launch Center', 
            latitude: 40.9675, 
            longitude: 100.2786, 
            altitude: 1000, 
            type: 'launch',
            frequency: 2.3, 
            diameter: 25, 
            range: 3500, 
            description: 'Chinese Human Spaceflight Center' 
        }
    ],
    military: [
        { 
            name: 'Cheyenne Mountain SFS', 
            latitude: 38.7434, 
            longitude: -104.8465, 
            altitude: 1981, 
            type: 'military',
            frequency: 5.8, 
            diameter: 30, 
            range: 5000, 
            description: 'NORAD Space Surveillance' 
        },
        { 
            name: 'Thule SFS', 
            latitude: 76.5311, 
            longitude: -68.7030, 
            altitude: 251, 
            type: 'radar',
            frequency: 5.8, 
            diameter: 46, 
            range: 6000, 
            description: 'Ballistic Missile Early Warning' 
        },
        { 
            name: 'RAF Fylingdales', 
            latitude: 54.3617, 
            longitude: -0.6704, 
            altitude: 290, 
            type: 'radar',
            frequency: 5.8, 
            diameter: 40, 
            range: 5500, 
            description: 'UK Space Surveillance' 
        },
        { 
            name: 'Clear SFS', 
            latitude: 64.2906, 
            longitude: -149.1898, 
            altitude: 213, 
            type: 'radar',
            frequency: 5.8, 
            diameter: 46, 
            range: 6000, 
            description: 'Alaska Space Tracking' 
        },
        { 
            name: 'Cape Cod SFS', 
            latitude: 41.7542, 
            longitude: -70.5389, 
            altitude: 40, 
            type: 'radar',
            frequency: 5.8, 
            diameter: 32, 
            range: 5000, 
            description: 'PAVE PAWS Radar' 
        }
    ],
    amateur: [
        { 
            name: 'AMSAT-NA HQ', 
            latitude: 38.9072, 
            longitude: -77.0369, 
            altitude: 125, 
            type: 'amateur',
            frequency: 0.435, 
            diameter: 3, 
            range: 1500, 
            description: 'Amateur Satellite Corporation' 
        },
        { 
            name: 'ARISS Telebridge', 
            latitude: 45.5017, 
            longitude: -73.5673, 
            altitude: 118, 
            type: 'amateur',
            frequency: 0.145, 
            diameter: 5, 
            range: 2000, 
            description: 'ISS Amateur Radio' 
        },
        { 
            name: 'JA1GDE Tokyo', 
            latitude: 35.6762, 
            longitude: 139.6503, 
            altitude: 40, 
            type: 'amateur',
            frequency: 0.435, 
            diameter: 3, 
            range: 1500, 
            description: 'Japanese Amateur Station' 
        },
        { 
            name: 'VK2KRR Sydney', 
            latitude: -33.8688, 
            longitude: 151.2093, 
            altitude: 58, 
            type: 'amateur',
            frequency: 0.435, 
            diameter: 3, 
            range: 1500, 
            description: 'Australian Amateur Station' 
        },
        { 
            name: 'G0KTN London', 
            latitude: 51.5074, 
            longitude: -0.1278, 
            altitude: 35, 
            type: 'amateur',
            frequency: 0.435, 
            diameter: 3, 
            range: 1500, 
            description: 'UK Amateur Station' 
        }
    ],
    commercial: [
        { 
            name: 'KSAT Svalbard', 
            latitude: 78.2300, 
            longitude: 15.3900, 
            altitude: 514, 
            type: 'tracking',
            frequency: 8.0, 
            diameter: 13, 
            range: 4000, 
            description: 'Kongsberg Satellite Services' 
        },
        { 
            name: 'SSC Esrange', 
            latitude: 67.8939, 
            longitude: 21.0839, 
            altitude: 329, 
            type: 'tracking',
            frequency: 2.3, 
            diameter: 13, 
            range: 3500, 
            description: 'Swedish Space Corporation' 
        },
        { 
            name: 'INTA Villafranca', 
            latitude: 40.4453, 
            longitude: -3.9519, 
            altitude: 650, 
            type: 'tracking',
            frequency: 2.3, 
            diameter: 15, 
            range: 3500, 
            description: 'Spanish Space Agency' 
        },
        { 
            name: 'DLR Weilheim', 
            latitude: 47.8806, 
            longitude: 11.0819, 
            altitude: 590, 
            type: 'tracking',
            frequency: 2.3, 
            diameter: 11, 
            range: 3000, 
            description: 'German Space Operations' 
        },
        { 
            name: 'USN Dongara', 
            latitude: -29.0458, 
            longitude: 114.9336, 
            altitude: 35, 
            type: 'tracking',
            frequency: 2.3, 
            diameter: 13, 
            range: 3500, 
            description: 'Universal Space Network' 
        }
    ]
};

/**
 * Coverage zone definitions for network generation
 */
export const COVERAGE_ZONES = {
    'global': { minLat: -70, maxLat: 70, minLon: -180, maxLon: 180 },
    'north-america': { minLat: 25, maxLat: 70, minLon: -170, maxLon: -50 },
    'europe': { minLat: 35, maxLat: 70, minLon: -10, maxLon: 40 },
    'asia-pacific': { minLat: -40, maxLat: 55, minLon: 60, maxLon: 180 },
    'polar': { minLat: 60, maxLat: 90, minLon: -180, maxLon: 180 },
    'equatorial': { minLat: -20, maxLat: 20, minLon: -180, maxLon: 180 }
};